import React from 'react';

const buildSrcDoc = (tagHtml) => {
  return `<!doctype html>
<html lang="ja">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style>
    html, body { margin: 0; padding: 0; background: transparent; }
  </style>
</head>
<body>
${tagHtml}
</body>
</html>`;
};

const IMobileAdIframe = ({ tagHtml, title = '広告', className, width = '160px', height = '600px' }) => {
  const srcDoc = React.useMemo(() => buildSrcDoc(tagHtml || ''), [tagHtml]);

  const resolvedWidth = typeof width === 'number' ? `${width}px` : width;
  const resolvedHeight = typeof height === 'number' ? `${height}px` : height;

  return (
    <iframe
      className={className}
      title={title}
      srcDoc={srcDoc}
      scrolling="no"
      style={{ width: resolvedWidth, height: resolvedHeight, border: 0, overflow: 'hidden', background: 'transparent' }}
    />
  );
};

export default IMobileAdIframe;
